import React, { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { getProjectSupportingDocuments } from "../../../actions/projectActions";
// import image1 from "../../../assets/img/avatar1.jpg";
// import avatar2 from "../../../assets/img/avatar2.jpg";
// import avatar3 from "../../../assets/img/avatar3.jpg";
import moment from 'moment'
import './style.css';

const ProjectPlanning = (props) => {

    // const dispatch = useDispatch();
    const [timelines, setTimelines] = useState([])

    useEffect(() => {
        if (props?.timelines) {
            setTimelines(props?.timelines);
        }
    }, [props.timelines])

    return (
        <>
            <div className="col-md-12">
                <div className="card">
                    <div className="header">
                        <h2>Project Planning</h2>
                        <ul className="header-dropdown dropdown dropdown-animated scale-left list-unstyled team-info">
                            { timelines && timelines.map((timeline, index) => ( 
                                <li key={index}>
                                    <img src={timeline.owner_profile_pic_url} title={timeline.owner_name} alt="Avatar" />
                                </li>
                            ))}
                            { timelines && timelines.map((timeline, index) => ( 
                                <li key={index}>
                                    <img src={timeline.approver_profile_pic_url} title={timeline.approver_name} alt="Avatar" />
                                </li>
                            ))}
                            {/* <li><img src={avatar2} alt="Avatar" /></li>
                            <li><img src={avatar3} alt="Avatar" /></li> */}
                        </ul>
                    </div>
                    <div className="body">
                        <div className="table-responsive">
                            <table className="table m-b-0">
                                <thead>
                                    <tr>                                    
                                        <th><strong>Stages</strong></th>
                                        <th>Owner</th>
                                        <th>Approver</th>
                                        <th>Status</th>
                                        <th>Created at</th>
                                        {/* <th>File</th>                                     */}
                                    </tr>
                                </thead>
                                <tbody>
                                    { timelines && timelines.map((timeline, index) => (
                                        <tr key={index}>
                                            <td className="col-font">
                                            {timeline.strategy}
                                            </td>
                                            <td className="col-box">
                                                <ul className="list-unstyled team-info">
                                                    <li><img src={timeline.owner_profile_pic_url} alt="Avatar"  title={timeline.owner_name}/> </li>
                                                    {/* <li><img src={avatar2} alt="Avatar" /></li>
                                                    <li><img src={avatar3} alt="Avatar" /></li> */}
                                                </ul>
                                            </td>
                                            <td  className="col-box">
                                                <ul className="list-unstyled team-info">
                                                    <li><img src={timeline.approver_profile_pic_url} alt="Avatar"   title={timeline.approver_name}/> </li>
                                                    {/* <li><img src={avatar2} alt="Avatar" /></li>
                                                    <li><img src={avatar3} alt="Avatar" /></li> */}
                                                </ul>
                                            </td>
                                            <td className="col-box">{ timeline.status }</td>
                                            <td className="col-box">{ moment(timeline.createdAt).format('DD/MM/YYYY') }</td>
                                            {/* <td className="col-box"><i className="fa fa-file-pdf-o fa-2x"></i></td> */}
                                        </tr>
                                    ))}
                                    
                                    
                                </tbody>
                            </table>
                            {!timelines.length ? <div className="text-center font-weight-bold pt-3">No matching records found</div> : null }
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}
export default ProjectPlanning;